import { render, staticRenderFns } from "./hour24.vue?vue&type=template&id=587f9250&"
import script from "./hour24.vue?vue&type=script&lang=ts&"
export * from "./hour24.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports